$0(document).ready(function () {

    ///////////////////////////////////////
    //show subscription or one-time options
    $0(".selector-button-sub").click(function(){
        $0(".price-wrapper, .purchase-button-wrapper").removeClass("active");
        $0(".price-wrapper-sub, .purchase-button-wrapper-sub").addClass("active");		
        $0(".selector-button-once, .selector-button-3pack").removeClass("selected");
        $0(this).addClass("selected");	
        $0(".subscription-extra").show();
        $0(".bottom-buy-bar-sub").addClass("active");
        $0(".bottom-buy-bar-once").removeClass("active");

        //reset the one-time options back to a 1pack
        $0(".option-price-header-once").removeClass("active");
        $0(".option-price-header-once.option-price-header-once-1").addClass("active");			
        $0(".onetime-option").removeClass("active");
        $0(".onetime-option.one-pack").addClass("active");
    });

    $0(".selector-button-once").click(function(){
        $0(".price-wrapper, .purchase-button-wrapper").removeClass("active");
        $0(".price-wrapper-once, .purchase-button-wrapper-once").addClass("active");		
        $0(".selector-button-sub, .selector-button-3pack").removeClass("selected");
        $0(this).addClass("selected");
        $0(".subscription-extra").hide();	
        $0(".bottom-buy-bar-sub").removeClass("active");
        $0(".bottom-buy-bar-once").addClass("active");	
    });	    

    $0(".selector-button-3pack").click(function(){
        $0(".price-wrapper, .purchase-button-wrapper").removeClass("active");
        $0(".price-wrapper-sub-3pack, .purchase-button-wrapper-sub-3pack").addClass("active");		
        $0(".selector-button-once, .selector-button-sub").removeClass("selected");
        $0(this).addClass("selected");	
        $0(".subscription-extra").show();

        //reset the one-time options back to a 1pack
        $0(".option-price-header-once").removeClass("active");
        $0(".option-price-header-once.option-price-header-once-1").addClass("active");			
        $0(".onetime-option").removeClass("active");
        $0(".onetime-option.one-pack").addClass("active");
    });	


    //show correct quantity for pricing and add-to-cart button
    $0(".bottle-selector-1").click(function(){
        $0(".price-qty, .purchase-button").removeClass("active");
        $0(".price-qty-1, .purchase-button.purchase-button-1").addClass("active");
    });
    $0(".bottle-selector-3").click(function(){
        $0(".price-qty, .purchase-button").removeClass("active");
        $0(".price-qty-3, .purchase-button.purchase-button-3").addClass("active");
    });
    $0(".bottle-selector-6").click(function(){
        $0(".price-qty, .purchase-button").removeClass("active");
        $0(".price-qty-6, .purchase-button.purchase-button-6").addClass("active");
    });		

    //display active quantity button
    $0(".bottle-selector").click(function(){
        $0(".bottle-selector").removeClass("selected");
        $0(this).addClass("selected");		
    });

    //display active one-time option button
    $0(".onetime-option.one-pack").click(function(){
        $0(".onetime-option").removeClass("active");
        $0(this).addClass("active");		
        $0(".purchase-button-wrapper-once .purchase-button").removeClass("active");
        $0(".purchase-button-wrapper-once .purchase-button-1").addClass("active");
        $0(".option-price-header-once").removeClass("active");
        $0(".option-price-header-once.option-price-header-once-1").addClass("active");	
        
    });
    $0(".onetime-option.two-pack").click(function(){
        $0(".onetime-option").removeClass("active");
        $0(this).addClass("active");		
        $0(".purchase-button-wrapper-once .purchase-button").removeClass("active");
        $0(".purchase-button-wrapper-once .purchase-button-2").addClass("active");	
        $0(".option-price-header-once").removeClass("active");
        $0(".option-price-header-once.option-price-header-once-2").addClass("active");	
    });
    $0(".onetime-option.three-pack").click(function(){
        $0(".onetime-option").removeClass("active");
        $0(this).addClass("active");		
        $0(".purchase-button-wrapper-once .purchase-button").removeClass("active");
        $0(".purchase-button-wrapper-once .purchase-button-3").addClass("active");
        $0(".option-price-header-once").removeClass("active");
        $0(".option-price-header-once.option-price-header-once-3").addClass("active");		
    });		

    //out of stock
    $0(".outofstock").click(function(){
      $0(".outofstock-popup").show();
      $0(".outofstock-popup-bkg").show();
    });
    $0(".outofstock-close").click(function(){
      $0(".outofstock-popup").hide();
      $0(".outofstock-popup-bkg").hide();
    });  

    ///////////////////////////
    //nourish pack selector
    ///////////////////////////
    $0(".nourish .multipack-selector.one-time.one-pack, .nourish .multipack-selector-once").click(function () {
        $0(".multipack-selector").removeClass("selected");
        $0(".multipack-selector.one-time.one-pack").addClass("selected");
        $0(".multipack-selector.subscribe.one-pack").addClass("selected");
        $0(".buy-button").removeClass("active");
        $0(".buy-button.buy-once.one-pack").addClass("active");
        $0(".upsell-form").removeClass("active");
        $0(".upsell-form.buy-once.one-pack").addClass("active");      
    });
    $0(".nourish .multipack-selector.one-time.two-pack").click(function () {
        $0(".multipack-selector").removeClass("selected");
        $0(".multipack-selector.one-time.two-pack").addClass("selected");
        $0(".multipack-selector.subscribe.one-pack").addClass("selected");
        $0(".buy-button").removeClass("active");
        $0(".buy-button.buy-once.two-pack").addClass("active");
        $0(".upsell-form").removeClass("active");
        $0(".upsell-form.buy-once.two-pack").addClass("active");            
    });
    $0(".nourish .multipack-selector.one-time.three-pack").click(function () {
        $0(".multipack-selector").removeClass("selected");
        $0(".multipack-selector.one-time.three-pack").addClass("selected");
        $0(".multipack-selector.subscribe.one-pack").addClass("selected");
        $0(".buy-button").removeClass("active");
        $0(".buy-button.buy-once.three-pack").addClass("active");
        $0(".upsell-form").removeClass("active");
        $0(".upsell-form.buy-once.three-pack").addClass("active");            
    });
    $0(".nourish .multipack-selector.subscribe.one-pack, .nourish .multipack-selector-sub").click(function () {
        $0(".multipack-selector").removeClass("selected");
        $0(".multipack-selector.subscribe.one-pack").addClass("selected");
        $0(".multipack-selector.one-time.one-pack").addClass("selected");``        
        $0(".buy-button").removeClass("active");
        $0(".buy-button.buy-sub.one-pack").addClass("active");
        $0(".upsell-form").removeClass("active");
        $0(".upsell-form.buy-sub.one-pack").addClass("active");      
    });
    $0(".nourish .multipack-selector.subscribe.two-pack").click(function () {
        $0(".multipack-selector").removeClass("selected");
        $0(".multipack-selector.subscribe.two-pack").addClass("selected");
        $0(".multipack-selector.one-time.two-pack").addClass("selected");``
        $0(".buy-button").removeClass("active");
        $0(".buy-button.buy-sub.two-pack").addClass("active");
        $0(".upsell-form").removeClass("active");
        $0(".upsell-form.buy-sub.two-pack").addClass("active");      
    });
    $0(".nourish .multipack-selector.subscribe.three-pack").click(function () {
        $0(".multipack-selector").removeClass("selected");
        $0(".multipack-selector.subscribe.three-pack").addClass("selected");
        $0(".multipack-selector.one-time.three-pack").addClass("selected");``
        $0(".buy-button").removeClass("active");
        $0(".buy-button.buy-sub.three-pack").addClass("active");
        $0(".upsell-form").removeClass("active");
        $0(".upsell-form.buy-sub.three-pack").addClass("active");            
    });  
    $0(".nourish .selector-button.selector-button-sub").click(function(){
      if ($0(".multipack-selector.subscribe.one-pack.selected").length) {
        console.log("sub one pack");
        $0(".pack-count").removeClass("active");
        $0(".pack-count.pack-sub.pack-1").addClass("active");        
        $0(".buy-button").removeClass("active");
        $0(".buy-button.buy-sub.one-pack").addClass("active");
        $0(".upsell-form").removeClass("active");
        $0(".upsell-form.buy-sub.one-pack").addClass("active");              
      } else if ($0(".multipack-selector.subscribe.two-pack.selected").length) {
        console.log("sub two pack");
        $0(".pack-count").removeClass("active");
        $0(".pack-count.pack-sub.pack-2").addClass("active");      
        $0(".buy-button").removeClass("active");
        $0(".buy-button.buy-sub.two-pack").addClass("active");        
        $0(".upsell-form").removeClass("active");
        $0(".upsell-form.buy-sub.two-pack").addClass("active");              
      } else if ($0(".multipack-selector.subscribe.three-pack.selected").length) {
        console.log("sub three pack");
        $0(".pack-count").removeClass("active");
        $0(".pack-count.pack-sub.pack-3").addClass("active");              
        $0(".buy-button").removeClass("active");
        $0(".buy-button.buy-sub.three-pack").addClass("active");        
        $0(".upsell-form").removeClass("active");
        $0(".upsell-form.buy-sub.three-pack").addClass("active");              
      } 
    }); 
      $0(".nourish .selector-button.selector-button-once").click(function(){
        if ($0(".multipack-selector.one-time.one-pack.selected").length) {
        console.log("one-time one pack");
        $0(".pack-count").removeClass("active");
        $0(".pack-count.pack-once.pack-1").addClass("active");
        $0(".buy-button").removeClass("active");
        $0(".buy-button.buy-once.one-pack").addClass("active");
        $0(".upsell-form").removeClass("active");
        $0(".upsell-form.buy-once.one-pack").addClass("active");                
      } else if ($0(".multipack-selector.one-time.two-pack.selected").length) {
        console.log("one-time two pack");
        $0(".pack-count").removeClass("active");
        $0(".pack-count.pack-once.pack-2").addClass("active");      
        $0(".buy-button").removeClass("active");
        $0(".buy-button.buy-once.two-pack").addClass("active");          
        $0(".upsell-form").removeClass("active");
        $0(".upsell-form.buy-once.two-pack").addClass("active");                          
      } else if ($0(".multipack-selector.one-time.three-pack.selected").length) {
        console.log("one-time three pack");
        $0(".pack-count").removeClass("active");
        $0(".pack-count.pack-once.pack-3").addClass("active");
        $0(".buy-button").removeClass("active");
        $0(".buy-button.buy-once.three-pack").addClass("active");
        $0(".upsell-form").removeClass("active");
        $0(".upsell-form.buy-once.three-pack").addClass("active");                          
      }    
    });  
});